import { MessageCircle } from "lucide-react";

const WHATSAPP_URL =
  "https://wa.me/523921003836?text=" +
  encodeURIComponent("Hola, me interesa información sobre los lotes de Real San José Residencial.");

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-btn"
      aria-label="Contactar por WhatsApp"
      className="whatsapp-pulse fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 bg-[#25D366] hover:bg-[#1faa52] text-white rounded-full p-4 shadow-xl hover:scale-110 transition-transform flex items-center justify-center"
    >
      <MessageCircle size={26} strokeWidth={1.8} fill="currentColor" stroke="white" />
      <span className="sr-only">WhatsApp</span>
    </a>
  );
}
